import InfoTooltip from "../InfoTooltip";

export const CellHeader = ({
  label,
  info,
}: {
  label: string;
  info: React.ReactNode;
}): React.ReactNode => {
  return (
    <div className="et-cell-heading-label group relative flex items-center justify-center gap-1 text-[#252525B2] font-bold text-sm">
      <span>{label}</span>
      {info && <InfoTooltip info={info} showIcon label={`About ${label}`} />}
    </div>
  );
};
